import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { DataProcessingProtocol } from "../processor";
import { BaseHttpProvider } from "./base";

export abstract class GetProvider<T> extends BaseHttpProvider<T> {
  constructor(public http: HttpClient) {
    super();
  }

  /**
   * Generate a get observable and
   */
  protected generateBaseObservable(
    urlSearchParams?: HttpParams,
  ): Observable<any> {
    const token: any =
      this.authProtocol != null && this.authProtocol != undefined
        ? this.authProtocol.getToken()
        : null;
    let get: any;
    let userToken: any;
    if (token instanceof Observable) {
      token.pipe(take(1)).subscribe((user) => {
        if (user != null) {
          userToken = user.token;
        } else {
          userToken = null;
        }
        get = this.http.get(this.endpoint, {
          headers: this.getHeaders(userToken),
          params: urlSearchParams,
        });
      });
    } else {
      get = this.http.get(this.endpoint, {
        headers: this.getHeaders(token),
        params: urlSearchParams,
      });
    }

    return get;
  }
}

export abstract class BaseGetProvider<T>
  extends GetProvider<T>
  implements DataProcessingProtocol {
  constructor(public http: HttpClient) {
    super(http);
    this.processingDelegate = this;
  }

  processResponse(response: any): Array<any> {
    if (!(response instanceof Array)) {
      response = [response];
    }

    const datas: any[] = [];
    for (const data of response) {
      const modelObj: any = new this.model().deserialize(data);
      datas.push(modelObj);
    }

    return datas;
  }
}

export abstract class BaseEavGetProvider<T>
  extends GetProvider<T>
  implements DataProcessingProtocol {
  constructor(public http: HttpClient) {
    super(http);
    this.processingDelegate = this;
  }

  processResponse(response: any): Array<any> {
    const data: any = this.model.eavDeserialize(response.attribute);

    return data;
    // this.model.eavDeserialize(response.attribute);
  }
}
